import {
  BETA_FEATURES_STORAGE_KEY,
  LEGACY_BETA_FEATURES_STORAGE_KEY,
} from "@spiriidk/connect-configs";

function migrateBetaFeaturesStorageKey() {
  if (typeof localStorage === "undefined") {
    return;
  }

  try {
    const legacyValue = localStorage.getItem(LEGACY_BETA_FEATURES_STORAGE_KEY);

    if (legacyValue === null) {
      return;
    }

    if (localStorage.getItem(BETA_FEATURES_STORAGE_KEY) === null) {
      localStorage.setItem(BETA_FEATURES_STORAGE_KEY, legacyValue);
    }
  } catch (error) {
    console.log("Failed to migrate beta features storage key:", error);
  }
}

export { migrateBetaFeaturesStorageKey };
